export const JOB_TYPES = [
  ["blood", "Blood", "#DB0000"], ["platelets", "Platelets", "#F59E0B"], ["plasma", "Plasma", "#EAB308"], ["breast_milk", "Breast milk", "#EC4899"],
  ["samples", "Samples", "#0EA5E9"], ["fmt", "FMT", "#A16207"], ["documents", "Documents", "#64748B"], ["equipment", "Equipment", "#16A34A"], ["other", "Other", "#6B7280"],
];
export const TYPE = Object.fromEntries(JOB_TYPES.map(([k, l, c]) => [k, { label: l, color: c }]));
export const PRIORITY = { emergency: "Emergency", urgent: "Urgent", routine: "Routine" };
export const JOB_STATUS = {
  pending_review: ["Needs review", "bg-orange-500/15 text-orange-500"], open: ["Waiting for rider", "bg-red-500/15 text-red-500"],
  assigned: ["Assigned", "bg-sky-500/15 text-sky-500"], accepted: ["Accepted", "bg-indigo-500/15 text-indigo-400"],
  collected: ["Collected", "bg-amber-500/15 text-amber-500"], delivered: ["Delivered", "bg-emerald-500/15 text-emerald-500"], cancelled: ["Cancelled", "bg-zinc-500/15 text-zinc-400"],
};
export const AREAS = ["Staffordshire", "Cheshire", "Shropshire", "West Midlands", "Other"];

export const navUrl = (p) => `https://www.google.com/maps/dir/?api=1&destination=${p.lat != null ? `${p.lat},${p.lng}` : encodeURIComponent(`${p.hospital_name} ${p.postcode || ""}`)}`;
export const w3wUrl = (w) => `https://what3words.com/${w}`;
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false }) : "");
export const placeLabel = (p) => `${p.hospital_name}${p.department ? ` · ${p.department}` : ""}`;

const localDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const whenLabel = (s) => {
  if (!s) return "";
  const [day, t] = [s.slice(0, 10), s.slice(11, 16)];
  const now = new Date();
  const tmr = new Date(now.getTime() + 86400000);
  if (day === localDay(now)) return `Today ${t}`;
  if (day === localDay(tmr)) return `Tomorrow ${t}`;
  return `${new Date(`${day}T12:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })} ${t}`;
};
export const minsUntil = (s) => (s ? Math.round((new Date(s) - Date.now()) / 60000) : null);
const RANK = { emergency: 0, urgent: 1, routine: 2 };
export const byUrgency = (a, b) => RANK[a.priority] - RANK[b.priority] || a.created_at.localeCompare(b.created_at);
export const isDueSoon = (j) => j.when !== "scheduled" || !j.scheduled_for || minsUntil(j.scheduled_for) <= 60;

export const stopsFor = (jobs) => jobs.flatMap((j) => [
  ...(["assigned", "accepted"].includes(j.status) ? [{ job: j, kind: "pickup", seq: j.pickup_seq }] : []),
  ...(j.status !== "delivered" ? [{ job: j, kind: "dropoff", seq: j.dropoff_seq }] : []),
]).sort((a, b) => a.seq - b.seq);

export const getGeo = () => new Promise((res) => {
  if (!navigator.geolocation) return res({});
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude }), () => res({}), { timeout: 5000, maximumAge: 60000 });
  return undefined;
});
